import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1310Model } from './kymw1310.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW1310InputModel } from './vo/kymw1310-input.model';
import { KYMW1310MultiPublishListModel } from './vo/kymw1310-multi-publish-list.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW1310PlanMultiPublishModel } from './vo/kymw1310-plan-multi-publish.model';
import { GetPlanMultiPublishService } from './api-services/get-plan-multi-publish.service';
import { RegistPlanMultiPublishService } from './api-services/regist-plan-multi-publish.service';

/**
 * Ｗ掲載設定画面を管理するクラス
 *
 * @export KYMW1310Component
 * @class KYMW1310Component
 */
@Component({
  selector: 'app-kymw1310',
  templateUrl: 'kymw1310.component.html',
  styleUrls: ['kymw1310.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1310Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;
  @ViewChild('dtg_MultiPublish', { static: true }) dtg_MultiPublish: FlexGrid;

  kymw1310Model: KYMW1310Model = new KYMW1310Model();

  // Ｗ掲載設定画面インプットVO
  private inputVO: KYMW1310InputModel;

  /**  親画面への連携値 */
  public setKYMW1310Parameter: Function;

  /**
   *Creates an instance of KYMW1310Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1310Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getPlanMultiPublishService: GetPlanMultiPublishService,
    private registPlanMultiPublishService: RegistPlanMultiPublishService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1310Component
   */
  public ngOnInit(): void {
    this.kymw1310Model.kymw1310Component = this;
    this.componentName = 'KYMW1310';
    this.dtg_MultiPublish.selectionMode = SelectionMode.Row;

    // manageの初期化
    this.kymw1310Model.registEnabled = false;
    this.kymw1310Model.guideGoodsName = '';
    this.kymw1310Model.guideStandardName = '';
    this.kymw1310Model.enableFlagIB = false;
    this.kymw1310Model.enableFlagTO = false;
    this.kymw1310Model.enableFlagGU = false;
    this.kymw1310Model.enableFlagTI = false;
    this.kymw1310Model.enableFlagSA = false;
    this.kymw1310Model.enableFlagTK = false;
    this.kymw1310Model.enableFlagNA = false;
    this.kymw1310Model.enableFlagNI = false;
    this.kymw1310Model.enableFlagKU = false;
    this.kymw1310Model.enableCoopCount = 0;
    this.kymw1310Model.multiPublishList = null;

    if (!PlessViewUtilsSub.isEmpty(this.inputVO.pCode)) {
      // Ｗ掲載設定情報取得要求をサーバに送信
      const vo = this.createPlanMultiPublishVO();
      this.getPlanMultiPublishService.execute(this.kymw1310Model, vo);
    }

    this.dtg_MultiPublish.itemsSourceChanged.addHandler(() => {
      this.dtg_MultiPublish.select(-1, -1);
    });

    this.dtg_MultiPublish.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_MultiPublish.hitTest(e);
      if ((0 <= ht.row) && (ht.col >= 1) && (ht.col <= 10) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`cb_${ht.col}_${ht.row}`).click();
      }
    });

    this.dtg_MultiPublish.focus();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW1310Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW1310InputModel>param;
    // 受注コード
    this.kymw1310Model.orderCode = this.inputVO.orderCode;
    // Ｐコード
    this.kymw1310Model.pCode = this.inputVO.pCode;
    // 編集ロック
    this.kymw1310Model.editLock = this.inputVO.editLock;
  }

  public setInputVO(inputVO: any): void {
    // 呼び出し元からの再表示要求時
    // 受渡情報の設定
    this.inputVO = <KYMW1310InputModel>inputVO;
    // 初期処理を呼び出す
    this.ngOnInit();
  }

  /**
   * 設定ボタンを押下した時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventRegist_CLICKHandler(event: Event): void {
    let bFlg: boolean = <boolean>false;
    let vo: KYMW1310MultiPublishListModel;

    for (let i = Number(0); i < this.kymw1310Model.multiPublishList.length; i++) {
      vo = this.kymw1310Model.multiPublishList[i];
      if (vo.publishFlagIB) {
        // いばらきがチェックされている場合
        bFlg = true;
        break;
      }
      if (vo.publishFlagTO) {
        bFlg = true;
        break;
      }
      if (vo.publishFlagGU) {
        bFlg = true;
        break;
      }
      if (vo.publishFlagTI) {
        bFlg = true;
        break;
      }
      if (vo.publishFlagSA) {
        bFlg = true;
        break;
      }
      if (vo.publishFlagTK) {
        bFlg = true;
        break;
      }
      if (vo.publishFlagNA) {
        bFlg = true;
        break;
      }
      if (vo.publishFlagNI) {
        bFlg = true;
        break;
      }

      if (vo.publishFlagKU) {
        bFlg = true;
        break;
      }
    }
    if (bFlg) {
      // １つでもチェックされている場合
      this.dialogService.openAlertGetMessage('Q0105', ['Ｗ掲載'], (closeDetail: number) => this.eventConfirm_CLICKHandler(closeDetail));
    } else {
      // １つもチェックされていない場合
      this.dialogService.openAlertGetMessage('Q0106', ['Ｗ掲載'], (closeDetail: number) => this.eventConfirm_CLICKHandler(closeDetail));
    }
  }

  /**
   * 確認メッセージダイアログが閉じられたときに呼び出されるイベント
   * @param closeEvent コールバック・イベントへの参照
   *
   */
  public eventConfirm_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // VO設定
      const vo = this.createPlanMultiPublishVO();
      // イベント発行
      this.registPlanMultiPublishService.execute(this.kymw1310Model, vo);
    }
  }

  /**
   * Ｗ掲載設定画面VO設定
   *
   * @return PlanMultiPublishVO
   */
  private createPlanMultiPublishVO(): KYMW1310PlanMultiPublishModel {
    const vo: KYMW1310PlanMultiPublishModel = new KYMW1310PlanMultiPublishModel();

    // 受注コード
    vo.orderCode = this.kymw1310Model.orderCode;
    // Pコード
    vo.pCode = this.kymw1310Model.pCode;

    // 多重掲載一覧
    vo.multiPublishList = this.kymw1310Model.multiPublishList;

    return vo;
  }

  /**
   * 「設定」ボタン押下後のCommandから呼び出される
   *
   */
  public updateParent(): void {
    // 呼出元画面の一覧再表示メソッドを呼ぶ
    this.setKYMW1310Parameter();
  }

  /**
   * 多重掲載設定一覧VO設定
   * 全生協をクリックして非活性の列以外全ての行にチェックをつけるまたは外す
   * @return void
   */
  public setCoopCheckbox(vo: any, bCheck: boolean): void {

    // 掲載フラグ（い）のチェック
    if (this.kymw1310Model.enableFlagIB) {
      vo.publishFlagIB = bCheck;
    }
    // 掲載フラグ（と）のチェック
    if (this.kymw1310Model.enableFlagTO) {
      vo.publishFlagTO = bCheck;
    }
    // 掲載フラグ（ぐ）のチェック
    if (this.kymw1310Model.enableFlagGU) {
      vo.publishFlagGU = bCheck;
    }
    // 掲載フラグ（ち）のチェック
    if (this.kymw1310Model.enableFlagTI) {
      vo.publishFlagTI = bCheck;
    }
    // 掲載フラグ（さ）のチェック
    if (this.kymw1310Model.enableFlagSA) {
      vo.publishFlagSA = bCheck;
    }
    // 掲載フラグ（とう）のチェック
    if (this.kymw1310Model.enableFlagTK) {
      vo.publishFlagTK = bCheck;
    }
    // 掲載フラグ（な）のチェック
    if (this.kymw1310Model.enableFlagNA) {
      vo.publishFlagNA = bCheck;
    }
    // 掲載フラグ（に）のチェック
    if (this.kymw1310Model.enableFlagNI) {
      vo.publishFlagNI = bCheck;
    }
    // 掲載フラグ（ク）のチェック
    if (this.kymw1310Model.enableFlagKU) {
      vo.publishFlagKU = bCheck;
    }
    return;
  }
}
